(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-character-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bh-artwork-slider')) {
    customElements.define('bh-artwork-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.bh-artwork-slider__track');
        this.slides = [...this.querySelectorAll('.bh-artwork-slider__slide')];
        this.index = 0;
        this.querySelector('.bh-artwork-slider__controls')?.removeAttribute('hidden');
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1), options);
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.bh-artwork-slider__slide');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.go(index, true);
        }, options);
        this.resize = new ResizeObserver(() => this.go(this.index, true));
        this.resize.observe(this.track);
        this.update();
      }
      go(index, instant = false) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        if (!this.track.clientWidth) return;
        this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        const count = this.querySelector('.bh-artwork-slider__count');
        if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.slides.forEach((slide, index) => { slide.inert = index !== this.index; });
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
